module.exports = __webpack_public_path__ + "static/media/uk.08378b58.jpg";